(function () {
  'use strict';
  if (window.AromaProductGalleryLightbox || !/^\/products\//.test(location.pathname)) return;
  window.AromaProductGalleryLightbox = true;

  var imageSelector = [
    '.ap-df__media-stage .ap-df__media-image',
    '.ap-hd__stage .ap-hd__image',
    '.ap-general__media-stage .ap-general__media-element:not(video)',
    '.ap-ro__media-stage > img',
    '.ap-cro__media-stage > img',
    '.ap-incense__media-stage > img',
    '.ap-sand-pdp__slide:not(.ap-sand-pdp__slide--video) img',
    '.ap-sand-v2__slide:not(.ap-sand-v2__slide--video) img',
    '.product__media img',
    '.product-media-container img'
  ].join(',');
  var gallerySelector = [
    '[data-ap-gallery]',
    '[data-ap-df] [data-ap-gallery]',
    '[data-ap-hd-gallery]',
    '[data-ap-general-gallery]',
    '[data-ap-sand-gallery]',
    '[data-ap-v2-gallery]',
    'media-gallery',
    '.product__media-gallery'
  ].join(',');
  var modal;
  var modalImage;
  var status;
  var previousButton;
  var nextButton;
  var images = [];
  var index = 0;
  var trigger;
  var pointerStart;

  function largestSource(image) {
    var candidates = (image.getAttribute('srcset') || '').split(',').map(function (candidate) {
      var parts = candidate.trim().split(/\s+/);
      return { url: parts[0], width: parseInt(parts[1], 10) || 0 };
    }).filter(function (candidate) { return candidate.url; });
    candidates.sort(function (a, b) { return b.width - a.width; });
    return candidates[0] ? candidates[0].url : (image.currentSrc || image.src);
  }

  function galleryImages(image) {
    var gallery = image.closest(gallerySelector);
    var found = gallery ? Array.from(gallery.querySelectorAll(imageSelector)) : [image];
    return found.filter(function (item, itemIndex) {
      return (item.currentSrc || item.src) && found.indexOf(item) === itemIndex;
    });
  }

  function build() {
    if (modal) return;
    modal = document.createElement('div');
    modal.className = 'ap-product-lightbox';
    modal.hidden = true;
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.setAttribute('aria-label', 'Product image viewer');
    modal.innerHTML = '<button class="ap-product-lightbox__close" type="button" aria-label="Close product image viewer"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18"/></svg></button><button class="ap-product-lightbox__arrow ap-product-lightbox__arrow--previous" type="button" aria-label="Previous product image"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="m15 5-7 7 7 7"/></svg></button><figure class="ap-product-lightbox__figure"><img class="ap-product-lightbox__image" alt=""></figure><button class="ap-product-lightbox__arrow ap-product-lightbox__arrow--next" type="button" aria-label="Next product image"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="m9 5 7 7-7 7"/></svg></button><p class="ap-product-lightbox__status" aria-live="polite"></p>';
    document.body.appendChild(modal);
    modalImage = modal.querySelector('.ap-product-lightbox__image');
    status = modal.querySelector('.ap-product-lightbox__status');
    previousButton = modal.querySelector('.ap-product-lightbox__arrow--previous');
    nextButton = modal.querySelector('.ap-product-lightbox__arrow--next');
    modal.querySelector('.ap-product-lightbox__close').addEventListener('click', close);
    previousButton.addEventListener('click', function () { show(index - 1); });
    nextButton.addEventListener('click', function () { show(index + 1); });
    modal.addEventListener('click', function (event) { if (event.target === modal) close(); });
  }

  function show(nextIndex) {
    if (!images.length) return;
    index = Math.max(0, Math.min(images.length - 1, nextIndex));
    var source = images[index];
    modalImage.src = largestSource(source);
    modalImage.alt = source.alt || 'Product image ' + (index + 1);
    status.textContent = (index + 1) + ' / ' + images.length;
    previousButton.disabled = index === 0;
    nextButton.disabled = index === images.length - 1;
  }

  function open(image) {
    build();
    trigger = image;
    images = galleryImages(image);
    index = Math.max(0, images.indexOf(image));
    show(index);
    modal.hidden = false;
    document.documentElement.classList.add('ap-product-lightbox-open');
    modal.querySelector('.ap-product-lightbox__close').focus();
    document.dispatchEvent(new CustomEvent('ap:pdp:image_zoom', { detail: { image_index: index + 1 } }));
  }

  function close() {
    if (!modal || modal.hidden) return;
    modal.hidden = true;
    modalImage.removeAttribute('src');
    document.documentElement.classList.remove('ap-product-lightbox-open');
    if (trigger && document.contains(trigger)) trigger.focus({ preventScroll: true });
  }

  function decorate(root) {
    (root || document).querySelectorAll(imageSelector).forEach(function (image) {
      if (image.closest('button, a') || image.dataset.apLightboxReady) return;
      image.dataset.apLightboxReady = 'true';
      image.classList.add('ap-product-gallery-zoomable');
      image.tabIndex = 0;
      image.setAttribute('role', 'button');
      image.setAttribute('aria-label', 'Open ' + (image.alt || 'product image'));
    });
  }

  document.addEventListener('pointerdown', function (event) {
    var stage = event.target.closest && event.target.closest('[data-ap-media-stage]');
    var image = event.target.closest && event.target.closest(imageSelector);
    if (stage || image) pointerStart = { x: event.clientX, y: event.clientY };
  }, true);

  document.addEventListener('pointercancel', function () { pointerStart = null; }, true);

  document.addEventListener('click', function (event) {
    var thumbnail = event.target.closest && event.target.closest('[data-ap-thumb]');
    if (thumbnail && window.matchMedia('(min-width: 750px)').matches) {
      var gallery = thumbnail.closest('[data-ap-gallery]');
      var mediaId = thumbnail.getAttribute('data-ap-thumb');
      var selectedImage = gallery && mediaId
        ? gallery.querySelector('[data-ap-media="' + mediaId + '"] .ap-df__media-image')
        : null;
      if (selectedImage) window.requestAnimationFrame(function () { open(selectedImage); });
      return;
    }
    var mediaStage = event.target.closest && event.target.closest('[data-ap-media-stage]');
    if (mediaStage && !event.target.closest('button, a, video, iframe')) {
      var activeImage = mediaStage.querySelector('.ap-df__media.is-active .ap-df__media-image');
      var moved = pointerStart && Math.hypot(event.clientX - pointerStart.x, event.clientY - pointerStart.y) > 8;
      pointerStart = null;
      if (activeImage && !moved) open(activeImage);
      return;
    }
    var image = event.target.closest && event.target.closest(imageSelector);
    if (!image || image.closest('button, a')) return;
    pointerStart = null;
    open(image);
  }, true);

  document.addEventListener('keydown', function (event) {
    if (!modal || modal.hidden) {
      var image = event.target.closest && event.target.closest(imageSelector);
      if (image && (event.key === 'Enter' || event.key === ' ')) {
        event.preventDefault();
        open(image);
      }
      return;
    }
    if (event.key === 'Escape') close();
    if (event.key === 'ArrowLeft') show(index - 1);
    if (event.key === 'ArrowRight') show(index + 1);
    if (event.key === 'Tab') {
      var focusable = Array.from(modal.querySelectorAll('button:not(:disabled)'));
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    }
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { decorate(document); }, { once: true });
  else decorate(document);
  document.addEventListener('shopify:section:load', function (event) { decorate(event.target); });
}());
